module.exports = __webpack_public_path__ + "img/OmniKnight.c3be3ac9.png";